"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var ModalComponent_1 = require("@CommonFrontend/Modal/ModalComponent");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var BemBuilder_1 = __importDefault(require("@CommonFrontend/Utils/BemBuilder"));
var c = (0, BemBuilder_1.default)("collaborator-invite-modal");
function RequestQwilrInvite(_a) {
    var closeModal = _a.closeModal;
    return (react_1.default.createElement(ModalComponent_1.Modal, { className: c() },
        react_1.default.createElement("div", null,
            react_1.default.createElement("img", { className: c("image"), src: "/Public/Assets/Images/request-confirm.png", alt: "An admin inviting a new user to the Qwilr dashboard" }),
            react_1.default.createElement(kaleidoscope_1.Heading, { strong: true, level: "3", className: c("heading") },
                "Your request has been sent!",
                react_1.default.createElement("br", null),
                "What's next?"),
            react_1.default.createElement(kaleidoscope_1.Text, { size: "s" },
                "Once the Admin of this page approves your request, you will get an invitation by email to join Qwilr!",
                " ",
                react_1.default.createElement("span", null, "\uD83E\uDD73")),
            react_1.default.createElement("div", { className: c("buttons") },
                react_1.default.createElement(kaleidoscope_1.Button, { size: kaleidoscope_1.ButtonSize.Large, type: kaleidoscope_1.ButtonType.Secondary, onClick: closeModal }, "Close")))));
}
exports.default = RequestQwilrInvite;
